import type { FaireProductEntity } from "../../entity_types/product";

export const p_g8ann4wxrf: FaireProductEntity = {
  token: "p_g8ann4wxrf",
  type: "product",
  name: "Bronson French Roast Craft Instant Coffee",
  brandToken: "b_d3mdkn2j3h",
  brandName: "Verve Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/ce8b6f1f42a0862bade3b6ed8cc5348cdafc082042d2fa51d6809017e2abd93f.png",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Creamy dark chocolate and a molasses-like sweetness define the darkest roast we offer. Pairs well with cream and sugar. Anyone who enjoys an extra bold coffee will love Bronson French Roast.\n\nAmazing things come in tiny packages. Verve Craft Instant Coffee is hand-roasted, small-batch brewed and preserved for your adventures. Ready to be brewed wherever and whenever. A week’s worth of premium coffee in your pocket.\n\nAdd one packet of Verve Craft Instant Coffee into your mug along with 10 ounces of hot or cold liquid (water, milk, or milk alternative), stir, and drink up.\n\nMakes 6 cups of coffee.\n\n• Coffee Details\nCountry\nVaries Seasonally\nTasting Notes\nMolasses, Dark Chocolate, Fig\nProducer\nVarious Producers\n\nProcess\nWashed\n\nElevation\n1700 - 2000 Meters\nHarvest\n\nOctober - March",
  tags: [],
  msrpDollars: 16.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:57.045Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
